export enum UserStatusEnum {
    PENDING = 'pending',
    ACCOUNT_CREATED = 'account_created',
    INFOR_UPDATED = 'infor_updated',
    PAYMENT_CONNECTED = 'payment_connected',
    CONTRACT_SIGNED = 'contract_singed',
    ACTIVE = 'active',
    DEACTIVATED = 'deactivated',
}
